
<template>
      <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            ¿Esta seguro de deshabilitar al docente?
          </h4>
        </template>


        <div class="con-form">
            <p class="mb-0" v-if="infoRow && infoRow.persona && infoRow.persona.apellido_paterno"><strong>{{infoRow.persona.apellido_paterno}} {{infoRow.persona.apellido_materno}} {{infoRow.persona.nombres}}</strong></p>
            <p class="mb-0" v-if="infoRow && infoRow.persona && infoRow.persona.matricula"><small>MATRÍCULA: </small> <strong>{{infoRow.persona.matricula}}</strong></p>
            <p class="mb-0" v-if="infoRow && infoRow.persona && infoRow.persona.correo"><small>CORREO: </small> <strong>{{infoRow.persona.correo}}</strong></p>
        </div>

        <template #footer>
          <div class="footer-dialog">
            <vs-row>
                <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat
                    @click="active = false"
                >
                    Cancelar
                </vs-button>
                </vs-col>
                <vs-col sm="6" lg="6">
                <vs-button
                    success
                    @click="getDeshabilitarDocente()"
                    class="ml-auto"
                >
                    Aceptar
                </vs-button>
                </vs-col>
            </vs-row>
          </div>
        </template>
      </vs-dialog>
</template>
<script>
import academico from '../../../../../api/requests/academico.js'
export default {
    props:[
        'value',
        'infoRow',
        'institucion'
    ],
    data:() => ({
        active: false,
        email: '',
        password: '',
        remember: false
    }),
    methods:{
        async getDeshabilitarDocente(){
            const loading = this.$vs.loading()
            try {
                const params = {
                    registro_academico_id: this.infoRow.id,
                    institucion_id: this.institucion
                }
                const {data: response} = await academico.getDeshabilitarDocente(params)
                this.$emit('refreshTable')
                this.active = false
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'Se ha desvinculado al docente.'
                })
            }
            catch{
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un error',
                    text: 'Favor de comunicarse con el administrador.'
                })
            }
        }
    },
    watch:{
        value (val) {
            this.active = val
        },      
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>
